import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import {StyledListShowMoreWrapper, StyledListShowMoreWrapperButton} from './StyledListShowMoreWrapper';

const ListShowMoreWrapper = ({
  items,
  maxVisible,
  itemVariants,
  renderItem,
  renderContent,
  itemKey,
  itemClass: ItemClass,
  showMoreLabel = 'More',
  ...rest
}) => {
  const [showAll, setShowAll] = useState(false);
  const visibleItems = showAll ? items : items.slice(0, maxVisible);
  const hasMore = items.length > maxVisible;

  return (
    <StyledListShowMoreWrapper {...rest}>
      <AnimatePresence initial={false}>
        {visibleItems.map((item, idx) => (
          <ItemClass
            as={motion.div}
            key={itemKey(item)}
            variants={itemVariants}
            initial='hidden'
            animate='visible'
            exit="exit"
            layout
            transition={{ type: 'spring', stiffness: 400, damping: 32, delay: showAll && idx >= maxVisible ? (idx - maxVisible) * 0.07 : 0 }}
          >
            {renderContent?.({ item, renderBar: renderItem })}
          </ItemClass>
        ))}
      </AnimatePresence>
      <AnimatePresence>
        {hasMore && !showAll && (
          <StyledListShowMoreWrapperButton type='link' onClick={() => setShowAll(true)}>
            {showMoreLabel} (+{items.length - maxVisible})
          </StyledListShowMoreWrapperButton>
        )}
      </AnimatePresence>
    </StyledListShowMoreWrapper>
  );
};

ListShowMoreWrapper.propTypes = {
  items: PropTypes.array.isRequired,
  maxVisible: PropTypes.number.isRequired,
  itemVariants: PropTypes.object.isRequired,
  renderItem: PropTypes.func,
  renderContent: PropTypes.func,
  itemKey: PropTypes.func.isRequired,
  itemClass: PropTypes.elementType.isRequired,
  showMoreLabel: PropTypes.string,
};

export default ListShowMoreWrapper;

